module.exports = "<!-- * ADMIN-CONTACT-US * -->\n<router-outlet></router-outlet>"